import { dbService } from './database';

class AuthService {
  private readonly AUTH_KEY = 'elimu_auth';

  async saveUserSession(user: any, token: string): Promise<void> {
    try {
      localStorage.setItem(this.AUTH_KEY, JSON.stringify({
        user: user,
        token: token,
        timestamp: new Date().toISOString()
      }));

      await dbService.db?.run(
        `INSERT OR REPLACE INTO user_sessions (id, user_data, token, created_at) 
         VALUES (1, ?, ?, datetime('now'))`,
        [JSON.stringify(user), token]
      );

      console.log('✅ User session saved offline');
    } catch (error) {
      console.error('❌ Failed to save session:', error);
    }
  }

  async getSavedSession(): Promise<any> {
    try {
      const saved = localStorage.getItem(this.AUTH_KEY);
      if (saved) {
        return JSON.parse(saved);
      }

      const result = await dbService.db?.query(
        'SELECT * FROM user_sessions WHERE id = 1'
      );
      
      if (result?.values && result.values.length > 0) {
        const row = result.values[0];
        return {
          user: JSON.parse(row.user_data),
          token: row.token,
          timestamp: row.created_at
        };
      }

      return null;
    } catch (error) {
      console.error('❌ Failed to get session:', error);
      return null;
    }
  }

  async isAuthenticated(): Promise<boolean> {
    const session = await this.getSavedSession();
    return session !== null;
  }

  async clearSession(): Promise<void> {
    localStorage.removeItem(this.AUTH_KEY);
    await dbService.db?.run('DELETE FROM user_sessions WHERE id = 1');
    console.log('✅ Session cleared');
  }
}

export const authService = new AuthService();
